export default "__VITE_ASSET__DGogr5Q0__"